import { render, staticRenderFns } from "./ClientUrssafCard.vue?vue&type=template&id=2b63f9b5"
import script from "./ClientUrssafCard.vue?vue&type=script&lang=js"
export * from "./ClientUrssafCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports